<template>

	<div
		:class="{
					'app_wrapper': mapStatus == 1,
					'': mapStatus == 0,
					'': mapStatus == 2,
				}"
		v-show="!$store.state.isMain">
				
			<NearByToolbar style="z-index: 20;" id="near_by_toolbar" ref="near_by_toolbar" 
			v-show="showMainTabs == false"/>

			<div :class="{
							'map_side_wrapper nearbymapContainer': mapStatus == 1,
							'no_map_wrapper nearbymapContainer': mapStatus == 0,
							'map_full_wrapper nearbymapContainer': mapStatus == 2
						} ">

				<!-- Layers List -->
				<!-- <div
				class="innerFiltersContainer"
				v-if="selectedNearByObject.hasOwnProperty('children')"
				>
					<button
						type="button"
						class="currFilters"
						@click="toggleFilterBox"
					>
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							class="icon"
						>
							<g fill="none" fill-rule="evenodd">
								<g>
									<g>
										<path
											d="M0 0H24V24H0z"
											transform="translate(-1244 -1133) translate(1244 1133)"
										></path>
										<g class="f1" fill="#00244E">
											<path
												d="M4 4h2V2H4v2zm3.8-2C7.4.8 6.3 0 5 0 3.7 0 2.6.8 2.2 2H0v2h2.2C2.6 5.2 3.7 6 5 6c1.3 0 2.4-.8 2.8-2H18V2H7.8zM13 10h2V8h-2v2zm1-4c-1.3 0-2.4.8-2.8 2H0v2h11.2c.4 1.2 1.5 2 2.8 2 1.3 0 2.4-.8 2.8-2H18V8h-1.2c-.4-1.2-1.5-2-2.8-2zM7 16h2v-2H7v2zm1-4c-1.3 0-2.4.8-2.8 2H0v2h5.2c.4 1.2 1.5 2 2.8 2 1.3 0 2.4-.8 2.8-2H18v-2h-7.2c-.4-1.2-1.5-2-2.8-2z"
												transform="translate(-1244 -1133) translate(1244 1133) translate(3 3)"
											></path>
										</g>
									</g>
								</g>
							</g>
						</svg>
						<div
							v-if="$store.state.selectedNearByObject != null"
							class="filterName"
						>
							{{ $store.state.selectedNearByObject.title }}
						</div>
					</button>

					<div
						v-show="showFilterBox == true"
						class="innerFiltersBox show"
					>
						<div
							class="scrollbar-container filterScrollWrap ps ps__rtl"
							style="max-height: 300px"
						>
							<ul class="innerFiltersList">
								<button
									v-for="(children, index) in $store.state
										.selectedNearByObject.children"
									:key="index"
									type="button"
									class="innerFilterItem"
									@click="selectFilter(children)"
								>
									<span class="">{{ children.title }}</span>
								</button>
							</ul>
							<div class="ps__rail-x" style="left: 0px; bottom: 0px">
								<div
									class="ps__thumb-x"
									tabindex="0"
									style="left: 0px; width: 0px"
								></div>
							</div>
							<div class="ps__rail-y" style="top: 0px; right: 205px">
								<div
									class="ps__thumb-y"
									tabindex="0"
									style="top: 0px; height: 0px"
								></div>
							</div>
						</div>
					</div>
				</div>	 -->



	

				<!-- Layers List New -->
				<div class="filterWrap innerFiltersContainer">
					<button
						@mouseleave="filter_hovered = false"
						@mouseover="filter_hovered = true"
						:class1="[
							showFilterOptions
								? 'btn big hollowClean filterBtn active'
								: '',
							'btn big hollowClean filterBtn ',
						]"
						@click="toggleShowFilter"

						class="map-action-after3"
					>
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							class="iconFilter"
						>
							<g fill="none" fill-rule="evenodd">
								<g>
									<g>
										<path
											d="M0 0H24V24H0z"
											transform="translate(-1244 -1133) translate(1244 1133)"
										></path>
										<g class="f1" fill="#02234b">
											<path
												d="M4 4h2V2H4v2zm3.8-2C7.4.8 6.3 0 5 0 3.7 0 2.6.8 2.2 2H0v2h2.2C2.6 5.2 3.7 6 5 6c1.3 0 2.4-.8 2.8-2H18V2H7.8zM13 10h2V8h-2v2zm1-4c-1.3 0-2.4.8-2.8 2H0v2h11.2c.4 1.2 1.5 2 2.8 2 1.3 0 2.4-.8 2.8-2H18V8h-1.2c-.4-1.2-1.5-2-2.8-2zM7 16h2v-2H7v2zm1-4c-1.3 0-2.4.8-2.8 2H0v2h5.2c.4 1.2 1.5 2 2.8 2 1.3 0 2.4-.8 2.8-2H18v-2h-7.2c-.4-1.2-1.5-2-2.8-2z"
												transform="translate(-1244 -1133) translate(1244 1133) translate(3 3)"
											></path>
										</g>
									</g>
								</g>
							</g>
						</svg>
						<span class="text"> סינון</span>
					</button>

					<div ref="dynamicDiv"
					v-show="showFilterOptions"
					class="customDropdown show"
					style="position: absolute; top: 100%; left: 0; right:0; overflow-y: auto; height: max-content; border-radius: 12px;
					overflow-y: hidden; overflow-x: hidden; margin-top: 70px;right: 5px;"
				>
						<div v-for="(layerGroup, index) in layerGroups" :key="index" style="position: relative;">
							<div
								style="
									display: grid;
									grid-template-columns: 90% 10%;
									cursor: pointer;
								"
								@click="showSubLayers(index)"
							>
								<div>
									<button style="margin-right: -20px" class="btn">
										{{ layerGroup.title }}
									</button>
								</div>
								<div style="display: flex; align-items: center" v-if="layerGroup.hasOwnProperty('children')">
									<button v-if="layerGroups[index].showSubLayers == true" class="arrow"></button>
									<button v-else class="arrow up"></button>
								</div>
							</div>	
							<div class="customDropdown show" 
								v-if="layerGroups[index].showSubLayers == true && layerGroup.hasOwnProperty('children')"
								style="position: absolute; top: 100%; left: 0; width: 100%; height: fit-content; z-index: 10;">
							<li
								v-for="(option, index) in layerGroup.children"
								:key="index"
								class="dropdownItem"
								@click="selectFilter(option)"
							>
								<button
									type="button"
									:class="[
										selectedSubLayer === option.title ? 'dropdownBtn blueText' : 'dropdownBtn'
									]"
								>
									{{ option.title }}
								</button>
							</li>
						</div>
						</div>
					</div>
				</div>

		



				<!-- Info Bubble -->
				<div
					v-if="featureSelected != null"
					class="pointDataBox show"
					data-font-size="10"
					data-font-size-type="px"
				>
					<div>
						<div class="innerData">
							<h3 class="title">{{ featureSelected.name }}</h3>
							<p class="address">
								{{ cleanLocation(featureSelected.address) }}
							</p>
							<div
								class="desc"
								v-if="
									$store.state.selectedNearByObject.mapLayerName ==
									'kidsGardensAndSchools'
								"
							>
								<div class="innerContent">
									<span class="plainText"
										>סוג חינוך:
										{{ featureSelected.educationType }} </span
									><span class="plainText"
										>סוג פיקוח:
										{{ featureSelected.supervisionType }}</span
									>
								</div>
								<div class="innerContent">
									<span class="plainText"
										>מגזר: {{ featureSelected.migzar }}</span
									>
								</div>
							</div>
							<div
								v-if="
									$store.state.selectedNearByObject.mapLayerName ==
									'busStations'
								"
								class="plainText desc"
							>
								<span class="">
									מס קווים בתחנה:
									{{ featureSelected.route_list.length }}
								</span>
							</div>
							<div
								v-if="
									$store.state.selectedNearByObject.mapLayerName ==
									'environment'
								"
								class="desc"
							>
								<div
									v-if="featureSelected.layerName == 'CELL_ACTIVE'"
									class="innerContent"
								>
									<span class="plainText"
										>סוג אתר: {{ featureSelected.type }}</span
									><span class="plainText"
										>בדיקה תקופתית אחרונה:
										{{
											featureSelected.lastCheck.substring(0, 10)
										}}</span
									>
									<span class="plainText"
										>עוצמת קרינה:
										{{ featureSelected.maxRadiation }}</span
									><span class="plainText"
										>טכנולוגיית שידור:
										{{ featureSelected.transmissionTechnology }}</span
									>
								</div>

								<div
									v-if="
										featureSelected.layerName == 'SVIVA_NITUR_MIFAL'
									"
									class="innerContent"
								>
									<span class="plainText"
										>רשות מקומית: {{ featureSelected.rashut }}</span
									>
									<span class="plainText"
										>למידע על פליטות מזהמים בארובות:

										<a :href="featureSelected.link" target="_blank"
											>קישור</a
										>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>	

				<MapDiv ref="map" id="map" />
			</div>

			<div :class="{
							'info_side': mapStatus == 1,
							'': mapStatus == 0,
							'': mapStatus == 2
						}" >
						
				
				<div class="container-fluid nearby">

				
					<div v-if="$store.state.loading == true" class="loading-container">
						<svg viewBox="25 25 50 50" class="loader-svg">
							<circle
								class="loader-path"
								cx="50"
								cy="50"
								r="20"
								fill="none"
								stroke="#1990d4"
								stroke-width="2"
							/>
						</svg>
					</div>

					<div class="nadlan-page mainAppPage" v-show="$store.state.loading == false">
						
						<!-- <NearByToolbar style="z-index: 20;" id="near_by_toolbar" ref="near_by_toolbar" /> -->
						<!-- v-show="showMainTabs == false" -->
						
						
							<div class="innerPage">

								<BreadCrumbs/>

								<NiceToMeets></NiceToMeets>

								<div
									v-if="$store.state.neighborhoodId != null && false"
									class="container-fluid compareNeighborhoodsBox sectionPadBottom"
								>
									<div class="titleContainer">
										<h2 class="title">איפה הכי כדאי לגור?</h2>
										<p class="plainText">
											בחר עד 3 שכונות להשוואה ובחנו את המחירים השונים, החינוך ועוד מידע
											על סביבת המגורים
										</p>
									</div>

									<div
										style="
											width: 100%;
											justify-content: center;
											align-items: center;
											display: -webkit-box;
											display: -ms-flexbox;
											display: -webkit-flex;
											display: flex;
										"
										v-for="(neig, index) in neigCompares"
										:key="index"
									>
										<button
											v-if="neig.id == null"
											@click="setModal(index)"
											class="comAddItemContainer"
											type="button"
										>
											<div
												class="comAddItem"
												data-font-size="16"
												data-font-size-type="px"
											>
												<img src="/images/addIcon.png" class="addIconComp" alt="" />{{
													neig.name
												}}
											</div>
										</button>

										<div v-else class="comNeighborhoodItem">
											<div class="textComNeighborhood">{{ neig.name }}</div>
											<button @click="removeNeig(index)" class="deleteIcon">
												<img
													class="icon"
													src="/images/autosuggestCloseIcon.png"
													alt=""
												/>
											</button>
										</div>
									</div>

									<div class="btnContainer">
										<button type="button" class="modalBtn" @click="showCompare()">
											בואו נראה לאן עוברים
											<div class="arrowWrap"><span class="long"></span></div>
										</button>
										<div style="color: red" v-if="showErrNeighMessage">
											אנא הוסף שכונה להשוואה
										</div>
									</div>
								</div>

								<div class="modal" v-show="openModal">
									<div class="modal-content1" id="modal_content1">
										<button
											@click="
												openModal = false;
												neigToAdd = null;
											"
											type="button"
											class="closeModalBtnContainer"
										>
											<span class="closeModalBtn" aria-hidden="true"></span
											><span class="sr-only">Close</span>
										</button>
										<div class="modalHeader" style="margin-top: 40px">
											<h2 class="title" style="font-size: 24px">הוספת שכונה</h2>
										</div>
										<div class="modalBody contanctContainer">
											<SearchBoxNeighCompare> </SearchBoxNeighCompare>
											<div class="borderTop"></div>
											<div class="modalSubTitle">השכונה הנוכחית</div>
											<button
												@click="neigToAdd = getCurrentNeig"
												type="button"
												class=""
											>
												<div
													:class="[
														neigToAdd == getCurrentNeig ? 'btnList current' : '',
														'btnList',
													]"
												>
													{{ $store.state.neighborhoodName }},
													{{ $store.state.settlementName }}
												</div>
											</button>
											<div v-show="all.length > 0" class="modalSubTitle paddingTop">
												שכונות דומות בסביבה
											</div>
											<div class="smallBtnsContainer" v-if="$store.state.info != null">
												<button
													@click="neigToAdd = neigh"
													type="button"
													class=""
													v-for="neigh in all"
													:key="neigh.id"
												>
													<div
														:class="[
															neigToAdd == neigh ? 'btnList current' : '',
															'btnList',
														]"
													>
														{{ neigh.name }}
													</div>
												</button>
											</div>
											<div class="btnsContainer">
												<button
													class="btn big white"
													type="button"
													@click="setModal(-1)"
												>
													ביטול
												</button>
												<button
													id="addNeighButton"
													@click="addNeigCompare(neigToAdd)"
													class="btn big blue"
													type="button"
													:disabled="isBtnDissabled()"
												>
													הוספה
												</button>
											</div>
										</div>
									</div>
								</div>

								<div v-if="openCompareModal == true" class="modal">
									<div class="modal-content1" id="compareModal">
										<button
											@click="openCompareModal = false"
											type="button"
											class="closeModalBtnContainer"
										>
											<span class="closeModalBtn" aria-hidden="true"></span
											><span class="sr-only">Close</span>
										</button>
										<div class="modalHeader" style="margin-top: 40px">
											<h2 class="title" style="font-size: 24px">השוואת שכונות</h2>
											<p class="plainText">
												שדות המסומנים ב * מתייחסים לחמש השנים האחרונות
											</p>
										</div>
										<div class="modalBody">
											<div id="tableCompare" class="compareTable textTable">
												<div class="tableCollom criteriaColumn">
													<div class="tableRow stickyRow">
														<div class="cell unitedCell">קריטריון להשוואה</div>
													</div>
													<div class="tableRow">
														<div class="cell cellHeader">מחיר חציוני</div>
													</div>
													<div class="tableRow">
														<div class="cell cellHeader">מגמת מחיר*</div>
													</div>
													<div class="tableRow">
														<div class="cell cellHeader">תשואה*</div>
													</div>
													<div class="tableRow">
														<div class="cell cellHeader">שכונה יוקרתית</div>
													</div>
													<div class="tableRow">
														<div class="cell cellHeader">
															ממוצע ציוני מיצ"ב שכונתיים (ממוצע ארצי 80)
														</div>
													</div>
													<div class="tableRow">
														<div class="cell cellHeader">המפה הפוליטית</div>
													</div>
													<div class="tableRow">
														<div class="cell cellHeader">מתקני ספורט</div>
													</div>
													<div class="tableRow">
														<div class="cell cellHeader">אופי מבנים</div>
													</div>
												</div>
												<div
													v-for="(neigComp, index) in neigCompares.filter(
														(x) => x.obj != null,
													)"
													:key="index"
													class="tableCollom"
												>
													<div class="tableRow stickyRow">
														<div class="cell cellHeader cellNeighborhood">
															{{ neigComp.name }}
															<div class="btnContainer">
																<button
																	@click="navigateTo(neigComp.id)"
																	type="button"
																	class="modalBtn"
																>
																	מעבר לשכונה
																	<div class="arrowWrap">
																		<span class="long"></span>
																	</div>
																</button>
															</div>
														</div>
													</div>
													<div v-if="neigComp.obj.trends != null" class="tableRow">
														<div
															class="cell"
															v-if="neigComp.obj.trends.medianAmount > 0"
														>
															{{
																neigComp.obj.trends.medianAmount.toLocaleString("he-IL")
															}}
															מש"ח
														</div>
														<div class="cell" v-else>נתון חסר</div>
													</div>
													<div v-else class="tableRow">
														<div class="cell">נתון חסר</div>
													</div>
													<div class="tableRow">
														<div class="cell">
															<div v-if="neigComp.obj.trends.rate > 0" class="div">
																<img
																	src="/images/arrowGreen.svg"
																	class="arrowIcon"
																	alt=""
																/>&nbsp;<span class="number">
																	{{ neigComp.obj.trends.rate }}
																	%</span
																>&nbsp;עלייה
															</div>
															<div v-else-if="neigComp.obj.trends.rate < 0" class="div">
																<img
																	src="/images/arrowRed.svg"
																	class="arrowIcon"
																	alt=""
																/>&nbsp;<span class="number">
																	{{ neigComp.obj.trends.rate }}
																	%</span
																>&nbsp;ירידה
															</div>
															<div v-else class="div">
																<span class="number"> נתון חסר </span>
															</div>
														</div>
													</div>
													<div class="tableRow">
														<div v-if="neigComp.obj.trends.yield != null" class="cell">
															{{ neigComp.obj.trends.yield }}
														</div>
														<div v-else class="cell">נתון חסר</div>
													</div>
													<div class="tableRow">
														<div
															v-if="neigComp.obj.trends.hasOwnProperty('grade')"
															class="cell"
														>
															{{ neigComp.obj.trends.grade }}/10
														</div>
														<div v-else class="cell">נתון חסר</div>
													</div>
													<div class="tableRow">
														<div class="cell" v-if="neigComp.obj.meitzav">
															{{ Math.floor(calculateAverage(neigComp.obj.meitzav)) }}
														</div>
														<div class="cell" v-else>נתון חסר</div>
													</div>
													<div class="tableRow">
														<div class="cell">
															<div
																v-if="neigComp.obj.politics.length > 0"
																class="boxCellContainer"
															>
																<div
																	v-for="(pol, p_index) in neigComp.obj.politics"
																	:key="p_index"
																	class="content"
																>
																	<div class="subTitle">
																		{{ Number(pol.val).toFixed(1) }}%
																	</div>
																	<div class="text">{{ pol.name }}</div>
																</div>
															</div>
															<div v-else>נתון חסר</div>
														</div>
													</div>
													<div class="tableRow">
														<div class="cell">{{ neigComp.obj.sports }}</div>
													</div>
													<div class="tableRow">
														<div class="cell">
															<div class="boxCellContainer">
																<div class="content">
																	<div class="subTitle">
																		{{ neigComp.obj.assets.high }} %
																	</div>
																	<div class="text">גבוהים</div>
																</div>
																<div class="content">
																	<div class="subTitle">
																		{{ neigComp.obj.assets.medium }}%
																	</div>
																	<div class="text">בינוניים</div>
																</div>
																<div class="content">
																	<div class="subTitle">
																		{{ neigComp.obj.assets.low }}%
																	</div>
																	<div class="text">נמוכים</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<NeighScroller ref="neigh_scroller" />
								<!-- whiteContainer -->

							</div>
	
							


					</div>

					

					<!-- <button style="z-index: 1000;" id="openBottomSheet" aria-controls="mwa-map"
						@mouseover="hover = true"
						@mouseleave="hover = false">
						<img v-if="!hover" src="images/minimap.png">
						<div v-else style="width: 110px; height: 74px; background-color: rgba(4, 68, 112, 0.85); display: flex; align-items: center; justify-content: center;">
							לפתוח מפה
						</div>
					</button> -->
				</div>
				<!-- :style="footerMap" -->
				<footer
				class="footer" 
				
				v-if="$store.state.loading == false "
			>
				<div class="personalArea">
					<h3 class="title">עסקאות חדשות לידי? יש פרויקט חדש בשכונה?</h3>
					<p class="plainText">
						קבלו מידע עדכני על סביבת המגורים שלכם ישירות למייל
					</p>
				</div>
				<button @click="$parent.$parent.showRegister()" class="btn blue round">
					הירשמו לקבלת עדכונים
				</button>
				<ul class="footerLinks">
					<li class="linkWrap">
						<button type="button" @click="$parent.$parent.showContact()" class="link">
							יצירת קשר
						</button>
					</li>
					<li class="linkWrap">
						<button class="link" @click="$parent.$parent.goToTerms()">תנאי שימוש</button>
					</li>
					<li class="linkWrap">
						<button class="link" @click="$parent.$parent.goToAccess()">נגישות</button>
					</li>
					<li class="linkWrap">
						<button class="link" @click="$parent.$parent.goToAbout()">אודות</button>
					</li>
				</ul>
			</footer>

			</div>
		


		</div>


</template>

<script src="https://code.jquery.com/jquery-2.1.1.min.js"></script>
<script src="https://www.govmap.gov.il/govmap/api/govmap.api.js"></script>

<script>
	import MapDiv from "./Map";
	// import NearByScroller from "./NearByScroller";
	import NearByToolbar from "./NearByToolbar";
	import NeighScroller from "./NeighScroller";
	import SearchBoxNeighCompare from "./SearchBoxNeighCompare";
	import BreadCrumbs from "./BreadCrumbs";
	import NiceToMeets from "./NiceToMeets";

	export default {
		name: "InfoPage",
		components: {
			MapDiv,
			// NearByScroller,
			NeighScroller,
			NearByToolbar,
			SearchBoxNeighCompare,
			BreadCrumbs,
			NiceToMeets,
		},
		data: () => ({
			layerGroups: [],
			layerGroupNames: {
				"kidsGardensAndSchools": "education",
				"busStations": "transport",
				"gardensAndParks": "parks",
				"arrangements": "services",
				"community": "services",
				"environment": "environment",
			},
			selectedInfo_to_nearByMenu: {
				services: "arrangements",
				religionPoints: "community",
				schools: "kidsGardensAndSchools",
				kindergardens: "kidsGardensAndSchools",
				community_centers: "community",
				parks: "gardensAndParks",
				clinics: "community",
				centers: "community",
				transport: "busStations",
				cell: "environment",
				mifal: "environment",
			},

			seletedInfoHebrew: {
				religionPoints: "מרכזים דתיים",
				schools: "בתי ספר",
				kindergardens: "גני ילדים",
				community_centers: "מרכזי קהילה",
				parks: "פארקים וגינות ציבוריות",
				clinics: "מרפאות",
				centers: "מרכזים",
				transport: "תחנות אוטובוס",
				cell: "אנטנות סלולריות",
				mifal: "מפעלים",
			},
			selectedSubLayer: '',
			selectedDealType: "כל העסקאות",
			dealTypeOptions: [
					{ value: "all", text: "כל העסקאות" },
					{ value: "first_hand", text: "יד ראשונה" },
					{ value: "second_hand", text: "יד שניה" },
				],
			showDealTypes: false,
			filter_hovered: false,
			showFilterOptions: false,
			zoomingTo: false,
			mapSet: false,
			scrollY: 0,
			route: null,
			activeCardIndex: -1,
			route_short_name: null,
			route_end: null,
			route_start: null,
			activeIndex: null,
			selectedRow: null,
			route_list: [],
			niceToMeets: [],
			selectedInfoHeb: "",
			hover: false,
			//svivaNiturAirList: [],
			additional: {
				HighBuilding: {
					High: null,
					Medium: null,
					Low: null,
				},
				RealEstateIndices: {
					LuxuryScore: 0,
					SecondHand: 0,
					FirstHand: 0,
					SquareMeter: 0,
					Property: 0,
					RentAllRooms: 0,
					AnnualReturn: 0,
					AveragePriceIncrease: 0,
					buy5Rooms: 0,
					buy4Rooms: 0,
					buy3Rooms: 0,
					buyAllRooms: 0,
				},
				WalkingAvgDistance: {
					PublicTransport: 0,
					Parks: 0,
					NaturalGreenAreas: 0,
					Shopping: 0,
					Schools: 0,
				},
				GreenAreasSum: 0,
				Demography: {
					MedianSetlIncome: 0,
					AcademicsInNeighborhood: 0,
					AcademicsInCity: 0,
					Sector: "לא ידוע",
					AvgChild: 0,
				},
				Transportation: {
					BusStationsCount: 15,
					BusLinesCount: 85,
					BusStationsList: [
						{
							stop_id: 12898,
							StationName:
								"\u05d3\u05e8\u05da \u05d6'\u05d1\u05d5\u05d8\u05d9\u05e0\u05e1\u05e7\u05d9/\u05d0\u05d4\u05e8\u05d5\u05e0\u05d5\u05d1\u05d9\u05e5",
							Location:
								"\u05e8\u05d7\u05d5\u05d1:\u05d3\u05e8\u05da \u05d6\u05d0\u05d1 \u05d6'\u05d1\u05d5\u05d8\u05d9\u05e0\u05e1\u05e7\u05d9 174 \u05e2\u05d9\u05e8: \u05d1\u05e0\u05d9 \u05d1\u05e8\u05e7 \u05e8\u05e6\u05d9\u05e3:   \u05e7\u05d5\u05de\u05d4:",
							BusLines: ["931", "978"],
							X: 185148.15119,
							Y: 666681.211746,
						},
						{
							stop_id: 12901,
							StationName:
								"\u05d6'\u05d1\u05d5\u05d8\u05d9\u05e0\u05e1\u05e7\u05d9/ \u05d0\u05d4\u05e8\u05d5\u05e0\u05d5\u05d1\u05d9\u05e5",
							Location:
								"\u05e8\u05d7\u05d5\u05d1:\u05d3\u05e8\u05da \u05d6\u05d0\u05d1 \u05d6'\u05d1\u05d5\u05d8\u05d9\u05e0\u05e1\u05e7\u05d9 107 \u05e2\u05d9\u05e8: \u05d1\u05e0\u05d9 \u05d1\u05e8\u05e7 \u05e8\u05e6\u05d9\u05e3:   \u05e7\u05d5\u05de\u05d4:",
							BusLines: ["180", "627", "69"],
							x: 184923.575218,
							y: 666709.917331,
						},
					],
					ParkingLotsCount: 0,
					AvgBusDistance: 0,
				},
				Environment: {
					CellActiveCount: 0,
					CellActives: [
						{
							Company: "\u05e4\u05dc\u05d0\u05e4\u05d5\u05df",
							SiteNum: "930010",
							City: "\u05db\u05e4\u05e8 \u05e1\u05d1\u05d0",
							Address: "\u05ea\u05dc \u05d7\u05d9 40",
							HafalaDate: "2017-09-07",
							Type: "\u05d0\u05e0\u05d8\u05e0\u05ea \u05e2\u05d5\u05e7\u05e5",
							Permit: "\u05d9\u05e9 \u05d4\u05d9\u05ea\u05e8",
							Intensity: 61.75,
						},
					],
				},
			},

			showShare: false,
			showFilterBox: false,
			setlCode: null,
			neighborhoodId: null,
			info: null,
			loading: true,
			featureSelected: null,
			subLayerSelected: null,
			pollutionData: null,
			clearExisting: true,
			openModal: false,
			neigToAddIndex: null,
			neigToAdd: null,
			neigCompares2: [
				{
					name: "הוסף שכונה להשוואה",
					id: null,
					obj: null,
				},
				{
					name: "הוסף שכונה להשוואה",
					id: null,
					obj: null,
				},
				{
					name: "הוסף שכונה להשוואה",
					id: null,
					obj: null,
				},
			],
			neigCompares: [
				{
					name: "הוסף שכונה להשוואה",
					id: null,
					obj: null,
				},
				{
					name: "הוסף שכונה להשוואה",
					id: null,
					obj: null,
				},
				{
					name: "הוסף שכונה להשוואה",
					id: null,
					obj: null,
				},
			],
			all: [],
			openCompareModal: false,
			showErrNeighMessage: false,

			selectedInfo: null,
		}),
		methods: {
			addMetaTag(a){
				var content =
					"מידע מקיף על " +
					a +
					" - נתונים דמוגרפיים, מוסדות חינוך, תחבורה, תשתיות"
				var meta = document.createElement("meta");
				meta.name = "description";
				meta.content = content;
				document.getElementsByTagName("head")[0].appendChild(meta);
			},
			adjustHeight() {
				if (this.$refs.dynamicDiv != null) {
					const dynamicDiv = this.$refs.dynamicDiv;
					if (dynamicDiv) {
						dynamicDiv.style.height = 'auto'; // Reset height to auto to recalculate it
						const height = dynamicDiv.scrollHeight + 12; // Get the actual height of content
						dynamicDiv.style.height = height  + 'px'; // Set the div height
					}
				}

			},
			filterObj(obj) {
				this.$store.state.selectedNearByObject = obj;
				this.$store.state.nearByMenu.forEach(function (obj) {
					obj.buttonClicked = false;
				});
				obj.buttonClicked = true;
			},
			showSubLayers(index) {
				this.selectedSubLayer = '';
				this.subLayerSelected = null;

				//toggle the showSubLayers property of the layer group
				this.layerGroups[index].showSubLayers = !this.layerGroups[index].showSubLayers;
				if (this.layerGroups[index].showSubLayers === true) {
					this.layerGroups.forEach((layerGroup, i) => {
						if (i !== index) {
							layerGroup.showSubLayers = false;
						}
					});
			
					// get the layer group using the index and this.selectedInfo_to_nearByMenu
					// for example -> selectedInfo schools == kidsGardensAndSchools
					// so the layer group is kidsGardensAndSchools

					// get the key from this.selectedInfo_to_nearByMenu where the value is kidsGardensAndSchools
					const selected = Object.keys(this.selectedInfo_to_nearByMenu).find(
						(key) => this.selectedInfo_to_nearByMenu[key] === this.layerGroups[index].mapLayerName,
					);

					var mapLayerName = this.selectedInfo_to_nearByMenu[selected];
					// filter the nearByMenu by mapLayerName
					var objects = this.$store.state.nearByMenu.filter(
						(x) => x.mapLayerName == mapLayerName,
					);

					// use the obj to change NearByScroller's selectedNearBy
					if (objects.length == 1) {
						//this.$refs.near_by_toolbar.filterObj(obj[0]);
						this.$store.state.selectedNearByObject = objects[0];
					}

					// scroll to the selected niceToMeet card
					const niceToMeets =  this.$refs.near_by_toolbar.niceToMeets;

					//extract the index of layer group in the nice to meets array
					const layerGroupIndex = niceToMeets.findIndex(niceToMeet => niceToMeet.name === this.layerGroupNames[this.layerGroups[index].mapLayerName]);

					//scroll to the selected item
					var element = document.getElementById(this.niceToMeets[layerGroupIndex].name);
					if (!element) {
						return;
					}
					// get elements child div - 'titleContainer':
					var titleContainer = element.querySelector(".titleContainer");
					if (titleContainer) {
						titleContainer.scrollIntoView({
							behavior: "smooth",
							block: "center",
						});
					}
				}


				var appVue = this;
				setTimeout(() => {
					appVue.adjustHeight();
				}, 100);
	
			},
			filterDealType(value, text) {
				// get selected deal type
				this.selectedDealType = text;
			},
			toggleShowFilter() {
				this.showFilterOptions = !this.showFilterOptions;
			},

			iconSvg(){
				
				// compose the above html into a string and return it
				return `<div class="gauge">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
					<circle cx="50" cy="50" r="45" stroke="#e0e0e0" stroke-width="4" fill="none" stroke-linecap="round" />
					<circle v-if="$parent.number !== 0" 
							cx="50" cy="50" r="45" 
							:stroke="color" 
							stroke-width="6" 
							fill="none" 
							stroke-dasharray="282.74" 
							:stroke-dashoffset="$parent.dashoffset"
							stroke-linecap="round" 
							transform="rotate(-90 50 50)" />
					<line v-if="$parent.number === 0" 
						x1="35" y1="50" x2="65" y2="50" 
						stroke="#e0e0e0" 
						stroke-width="4" 
						stroke-linecap="round" />
					<text v-if="$parent.number !== 0" 
						x="50" y="50" 
						:fill="color" 
						font-family="rubik, arial" 
						font-size="38" 
						text-anchor="middle" 
						dominant-baseline="central" 
						font-weight="bold">{{ $parent.number }}</text>
				</svg>
			</div>`
			},
			handleClick(link) {
				if (!link) {
					return;
				}
				// Handle the click event, e.g., navigate to the link or open in a new tab
				window.open(link, "_blank"); // Example: open the link in a new tab
			},
			async fetchBusData() {
				var appVue = this;
				var type = "settlement";
				var id = appVue.$store.state.setlCode;
				//view=neighborhood_info => type = "neighborhood"
				//view=settlement_info => type = "settlement"
				if (appVue.$store.state.view === "neighborhood_info") {
					type = "neighborhood";
					id = appVue.$store.state.neighborhoodId;
				}
				const bus_url =
					appVue.$store.state.config.s3_url_base +
					"/additional_info/bus/" +
					type +
					"/" +
					id +
					".json";
				try {
					// check if bus_url json file exists
					const response = await fetch(bus_url);
					if (!response.ok) {
						// If the response is not OK, throw an error to be caught in the catch block
						throw new Error("File not found or access forbidden");
					}

					const text = await response.text();

					// Replace NaN with null in the raw text
					const validJsonText = text.replace(/NaN/g, "null");
					// Parse the valid JSON text
					const data = JSON.parse(validJsonText);
					appVue.nearByObjects.busStations = data.BusStationsList || [];
					appVue.additional.TransportationGlobal =
						appVue.additional.Transportation;
					appVue.additional.Transportation = data;

					for (let i = 0; i < appVue.nearByObjects.busStations.length; i++) {
						let route_list = appVue.nearByObjects.busStations[i].route_list;
						appVue.nearByObjects.busStations[i].groupedRoutes =
							route_list.reduce((acc, route) => {
								if (!acc[route.agency_name]) {
									acc[route.agency_name] = [];
								}
								acc[route.agency_name].push(route);
								return acc;
							}, {});
					}

					// Continue with "Nice to meet" logic here
				} catch (error) {
					console.warn("Error fetching the bus data:", error);
					// Fallback logic if the file is not found or a 403 error occurs
					appVue.additional.Transportation = {};
					appVue.nearByObjects.busStations = [];
					appVue.additional.Transportation.BusLinesCount = 0;
					appVue.additional.Transportation.BusStationsList = [];

					// Continue with "Nice to meet" logic even if additional_info/bus JSON does not exist
					// Continue with "Nice to meet" logic here
				}
			},
			toggleCollapseCard(index) {
				if (this.isMobile) {
					// scroll up to the title of the card
					if (this.activeCardIndex > -1 && this.activeCardIndex !== index) {
						setTimeout(() => {
							const card = document.getElementById(`card-${index}`);
							const elementPosition =
								card.getBoundingClientRect().top + window.pageYOffset;
							window.scrollTo({
								top: elementPosition - 200,
								behavior: "smooth",
							});
						}, 100);
					}
					if (this.activeCardIndex === index) {
						this.activeCardIndex = -1;
					} else {
						this.activeCardIndex = index;
					}
				}
			},
			async getCellActives(wkt) {
				const appVue = this;
				govmap
					.intersectFeaturesLongGeom({
						geometry: wkt,
						// "COMPANY": "סלקום",
						// "SITE_NUM": "3297",
						// "CITY": "רעננה",
						// "ADDRESS": "רח` קזן 3",
						// "LOCAL_AUTH": "רעננה",
						// "SHIPUT": "רעננה",
						// "X": 188975,
						// "Y": 676166,
						// "TYPE": "מתקן גישה אלחוטי",
						// "LAST_BEDIK": "20/03/2024 00:00:00",
						// "PERMIT": "יש היתר",
						// "MAX_INTENS": "מבנה מגורים ברחוב גור מרדכי 2",
						// "INTENSITY": "38.71",
						// "PERCENT": "4.54",
						// "HAKAMA_DAT": "14/12/2021 00:00:00",
						// "HAFALA_DAT": "03/08/2023 00:00:00",
						// "HAKAMA_FIL": "http://documents.sviva.gov.il/B001_2_3297_20211214_1759.pdf",
						// "HAFALA_FIL": "http://documents.sviva.gov.il/B002_2_3297_20230803_1222.pdf",
						// "TECHNOLOGY": "דור 3 4",
						// "LENGTH": "0",
						// "AREA": "0",
						// "GOVMAP_CENTROID": "POINT  ( 188975.00000000 676166.00000000)",
						// "GEOMTOTEXT_SAVEKEYWORD": "POINT  ( 188975.00000000 676166.00000000)",
						// "OBJECTID": 151166,
						// "IsEditable": true
						layers: ["CELL_ACTIVE"],
						// "Company": "\u05e4\u05dc\u05d0\u05e4\u05d5\u05df",
						// "SiteNum": "930010",
						// "City": "\u05db\u05e4\u05e8 \u05e1\u05d1\u05d0",
						// "Address": "\u05ea\u05dc \u05d7\u05d9 40",
						// "HafalaDate": "2017-09-07",
						// "Type": "\u05d0\u05e0\u05d8\u05e0\u05ea \u05e2\u05d5\u05e7\u05e5",
						// "Permit": "\u05d9\u05e9 \u05d4\u05d9\u05ea\u05e8",
						// "Intensity": 61.75

						fields: [
							"COMPANY",
							"SITE_NUM",
							"CITY",
							"ADDRESS",
							"HAFALA_DAT",
							"TYPE",
							"PERMIT",
							"INTENSITY",
						],
						getShapes: true,
						maxResults: 500,
					})
					.then((response) => {
						response.features.forEach((feature) => {
							appVue.additional.Environment.CellActives.push({
								company: feature.properties.COMPANY,
								siteNum: feature.properties.SITE_NUM,
								city: feature.properties.CITY,
								address: feature.properties.ADDRESS,
								hafalaDate: feature.properties.HAFALA_DAT,
								type: feature.properties.TYPE,
								permit: feature.properties.PERMIT,
								intensity: feature.properties.INTENSITY,
							});
						});
						appVue.additional.Environment.CellActiveCount =
							response.features.length;
					});

				// govmap.intersectFeatures...
			},
			zoomToWktExtent(wkt) {
				// Extract coordinates from the WKT string
				const coordsString = wkt.match(/LINESTRING \((.+)\)/)[1];
				const coordsArray = coordsString
					.split(", ")
					.map((coord) => coord.split(" ").map(Number));

				// Initialize min and max values
				let xmin = coordsArray[0][0],
					ymin = coordsArray[0][1];
				let xmax = coordsArray[0][0],
					ymax = coordsArray[0][1];

				// Loop through coordinates to find min and max values
				coordsArray.forEach((coord) => {
					let x = coord[0],
						y = coord[1];
					if (x < xmin) xmin = x;
					if (x > xmax) xmax = x;
					if (y < ymin) ymin = y;
					if (y > ymax) ymax = y;
				});

				// Return the extent
				return { xmin, ymin, xmax, ymax };
			},
			showRouteLine(route) {
				const appVue = this;

				appVue.zoomingTo = true;

				appVue.route = route;

				this.featureSelected = null;

				var url =
					appVue.$store.state.config.s3_url_base +
					"/additional_info/bus/geom/" +
					route.geom_id +
					".json";
				fetch(url)
					.then((response) => response.text())
					.then((text) => {
						// Replace NaN with null in the raw text
						const validJsonText = text.replace(/NaN/g, "null");
						// Parse the valid JSON text
						const data = JSON.parse(validJsonText);

						appVue.route_short_name = data.route_short_name;
						appVue.route_end = data.end;
						appVue.route_start = data.start;
						const wkt = data.wkt;
						var l_data = {
							wkts: [wkt],
							names: [appVue.route_short_name],
							geometryType: govmap.drawType.Polyline,
							defaultSymbol: {
								color: [78, 244, 233, 1],
								//color: [13, 62, 251, 1],
								width: 4,
							},
							symbols: [],
							clearExisting: true,
							data: {
								tooltips: ["קו " + appVue.route_short_name],
								headers: [appVue.route_short_name],
								bubbles: [appVue.route_short_name],
							},
						};
						// appVue.$store.state.showMap = true;
						if (this.$store.state.mapStatus==0){
							this.$store.state.mapStatus=1;
						}

							

						setTimeout(() => {
							govmap.zoomToExtent(appVue.zoomToWktExtent(wkt));
							setTimeout(() => {
								appVue.zoomingTo = false;
							}, 300);
						}, 300);
						govmap.displayGeometries(l_data).then(function (response) {});
					})
					.catch((error) => {
						console.error("Error fetching or parsing the JSON:", error);
					});

				this.selectedInfoHeb = this.seletedInfoHebrew[this.selectedInfo];

				var mapLayerName = this.selectedInfo_to_nearByMenu[this.selectedInfo];
				// filter the nearByMenu by mapLayerName
				var obj = this.$store.state.nearByMenu.filter(
					(x) => x.mapLayerName == mapLayerName,
				);
				// use the obj to change NearByScroller's selectedNearBy
				if (obj.length == 1) {
					//this.$refs.near_by_scroller.filterObj(obj[0]);
					if (this.$refs.near_by_toolbar != null){
						this.$refs.near_by_toolbar.filterObj(obj[0]);
					}
				}

				
			},
			getAgencyIconUrl(agency) {
				// Return the URL of the agency icon based on the agency name
				const icons = {
					מטרופולין: "images/transport/agancies/metropoline.png",
					תנופה: "images/transport/agancies/tnufa.svg",
					אגד: "images/transport/agancies/egged.png",
					"אלקטרה אפיקים תחבורה":
						"images/transport/agancies/electra-afikim.png",
					דן: "images/transport/agancies/dan.svg",
					"ש.א.מ": "images/transport/agancies/shaam.svg",
					"נסיעות ותיירות": "images/transport/agancies/ntt.svg",
					"גי.בי.טורס": "images/transport/agancies/gbt.png",
					"מועצה אזורית אילות": "images/transport/agancies/eilot.png",
					"נתיב אקספרס": "images/transport/agancies/nativ-express.png",
					סופרבוס: "images/transport/agancies/superbus.png",
					קווים: "images/transport/agancies/kavim.svg",
					כרמלית: "images/transport/agancies/carmelit.png",
					כפיר: "images/transport/agancies/cfir.svg",
					תבל: "images/transport/agancies/dankal.png",
					גלים: "images/transport/agancies/galim.png",
					"מועצה אזורית גולן": "images/transport/agancies/golan.png",
					"אלקטרה אפיקים": "images/transport/agancies/electra-afikim.png",

					// Add other agency icons here if needed
				};
				return icons[agency] || "images/transport/agancies/bus.svg";
			},
			async getNeighborhoodWkt() {
				var appVue = this;
				var neigData = await govmap.intersectFeaturesByWhereClause({
					layerName:  "KSHTANN_NEIGHBORHOODS",
					fields: ["UNIQ_ID"],
					getShapes: true,
					whereClause: "UNIQ_ID = " + this.$store.state.neighborhoodId
				});

				if (neigData.status == 0) {
					if (neigData.data != null && neigData.data.length > 0) {
						neigData.data.forEach(function (item) {
							var wkt = item.Values[1];
							appVue.getMifalim(wkt);
						});
					}
				}
			},
			async getSetlWkt(setl_code) {
				var appVue = this;
				var setlData = await govmap.intersectFeaturesByWhereClause({
					layerName: "KSHTANN_SETL_AREA",
					fields: ["SETL_CODE"],
					getShapes: true,
					whereClause: "SETL_CODE = " + setl_code
				});

				if (setlData.status == 0) {
					if (setlData.data != null && setlData.data.length > 0) {
						setlData.data.forEach(function (item) {
							var wkt = item.Values[1];
							appVue.getMifalim(wkt);
						});
					}
				}

			},
			async svivaNiturAir() {
				const appVue = this;
				this.$store.state.svivaNiturAirList = [];
				var wkt;
				//setTimeout(() => {
				// get neighborhood wkt...
				if (appVue.$store.state.neighborhoodId == null && appVue.$store.state.setlCode != null) {
					appVue.getSetlWkt(appVue.$store.state.setlCode);
				}
				if (appVue.$store.state.neighborhoodId != null) {
					appVue.getNeighborhoodWkt(appVue.$store.state.neighborhoodId);
				}
				
				//}, 100);
			},
			getMifalim(wkt){
				var appVue = this;
							//var wkt = appVue.nearByObjects.wkt;
							govmap.intersectFeaturesLongGeom({
									geometry: wkt,
									layerName: "SVIVA_NITUR_MIFAL",
									fields: [
										"HYPERLINK",
										"MIFAL",
										"MACHOZ",
										"RASHUTMEKO",
										"YISHUV",
										"X",
										"Y",
									],
									getShapes: true,
									maxResults: 500,
							})
							.then(function (e) {
								if (e.message == "אין תוצאות") {
									return;
								}
								if (e.data == null) {
									return;
								}

								// check if the data is an array
								if (!Array.isArray(e.data)) {
									return;
								}
								e.data.forEach((i) => {
									var obj = {
										ObjectId: i.ObjectId,
										Mifal: i.Values[1],
										Rashut: i.Values[3],
										Yishuv: i.Values[4],
										x: i.Values[5],
										y: i.Values[6],
										Link: i.Values[0],
									};
									appVue.$store.state.svivaNiturAirList.push(obj);
								});
								//where name == "environment" && items[2]
								var the_item = appVue.niceToMeets.find((item) => item.name == "environment" && item.items[2]);
								the_item.items[2].display = appVue.$store.state.svivaNiturAirList.length;
								the_item.items[2].table.data = appVue.$store.state.svivaNiturAirList.map(
									(item, index) => ({
										index: index + 1,
										name: item.Mifal.trimEnd(),
										yishuv: item.Yishuv,
										link: item.Link,
										x: item.x,
										y: item.y,
									}),
								);
							});
			},
			goToEnv() {
				window.open("https://air.sviva.gov.il/", "_blank").focus();
			},
			cleanLocation(sentence) {
				// Remove the labels
				// sentence pattern:
				// רחוב:בן גוריון 57 עיר: כפר סבא רציף: קומה:

				if (sentence == null) {
					return "";
				}

				sentence = sentence.replace(/רחוב:/g, "");
				sentence = sentence.replace(/עיר:/g, "");
				sentence = sentence.replace(/רציף:/g, "");
				sentence = sentence.replace(/קומה:/g, "");
				sentence = sentence.replace(/""/g, '"');

				// Trim any extra spaces
				sentence = sentence.trim();

				// Remove extra spaces between words
				sentence = sentence.replace(/\s\s+/g, " ");

				return sentence;
			},

			kavimCount(feature) {
				if (feature.hasOwnProperty("stop_id")) {
					return feature.BusLines.length;
				} else {
					var busStations_list =
						this.additional.Transportation.BusStationsList.filter(
							(x) => feature.id == "station_" + x.stop_id,
						);
					if (busStations_list.length == 1) {
						return busStations_list[0].BusLines.length;
					}
				}
			},
			zoomTo(item) {
				var _appVue = this;
				_appVue.zoomingTo = true;
				// _appVue.$store.state.showMap = true;
				_appVue.route_short_name = null;

				//open bottom sheet
				// document.getElementById("bottomSheet").classList.add("active");
				if (this.$store.state.mapStatus==0){
					this.$store.state.mapStatus=1;
				}

				this.selectedInfoHeb = this.seletedInfoHebrew[this.selectedInfo];

				var mapLayerName = this.selectedInfo_to_nearByMenu[this.selectedInfo];
				// filter the nearByMenu by mapLayerName
				var obj = this.$store.state.nearByMenu.filter(
					(x) => x.mapLayerName == mapLayerName,
				);
				// use the obj to change NearByScroller's selectedNearBy
				if (obj.length == 1) {
					//this.$refs.near_by_scroller.filterObj(obj[0]);
					if (this.$refs.near_by_toolbar != null){
						this.$refs.near_by_toolbar.filterObj(obj[0]);
					setTimeout(() => {
						if (this.selectedInfo == "transport") {
							// filter this.nearByObjects.busStations where id = 'station_' + item.id
							var busStations_list = this.nearByObjects.busStations.filter(
								(x) => x.id == "station_" + item.stop_code,
							);
							//
							if (busStations_list.length == 1) {
								this.featureSelected = busStations_list[0];
							}
							govmap.zoomToXY({
								x: item.x,
								y: item.y,
								level: 10,
								marker: false,
							});
						} else if (this.selectedInfo == "cell") {
							// if no x y
							if (item.x == null || item.y == null) {
								// get x y from item.id
								// by item.index
								var cellActives_list =
									this.additional.Environment.CellActives[item.index - 1];
								item.x = cellActives_list.x;
								item.y = cellActives_list.y;
							}
							var params = {
								LayerName: "CELL_ACTIVE",
								Point: {
									x: item.x,
									y: item.y,
								},
								Radius: 50,
							};
							var addrId = null;
							govmap.getLayerData(params).then(function (response) {
								if (response.data == null) {
									// stop highlight
									govmap.clearSelection();
									return;
								}
								var a = response.data[0].Fields;
								// get from a where FieldName == "POLYGON_ID"
								var obj = {};
								_appVue.featureSelected = {};
								a.forEach((element) => {
									obj[element.FieldName] = element.Value;
								});

								_appVue.featureSelected.layerName = "CELL_ACTIVE";

								_appVue.featureSelected.name =
									obj["חברה"] + " " + obj["מספר אתר"];
								_appVue.featureSelected.address = obj["כתובת האתר"];
								_appVue.featureSelected.type = obj["סוג אתר"];
								_appVue.featureSelected.lastCheck = obj["בדיקה תקופתית אחרונה"];
								_appVue.featureSelected.maxRadiation =
									obj["עוצמת קרינה מרבית ביח' מיקרו לסמ\"ר"];
								_appVue.featureSelected.percentage =
									obj["אחוז מסך החשיפה שקבע ארגון הבריאות העולמי"];
								_appVue.featureSelected.transmissionTechnology =
									obj["טכנולוגיית שידור"];
							});
							govmap.zoomToXY({
								x: item.x,
								y: item.y,
								level: 10,
								marker: false,
							});
						} else if (this.selectedInfo == "mifal") {
							var params = {
								LayerName: "SVIVA_NITUR_MIFAL",
								Point: {
									x: item.x,
									y: item.y,
								},
								Radius: 50,
							};

							govmap.getLayerData(params).then(function (response) {
								if (response.data == null) {
									// stop highlight
									govmap.clearSelection();
									return;
								}
								var a = response.data[0].Fields;
								var obj = {};
								_appVue.featureSelected = {};
								a.forEach((element) => {
									obj[element.FieldName] = element.Value;
								});

								_appVue.featureSelected.layerName = "SVIVA_NITUR_MIFAL";
								_appVue.featureSelected.name = obj["שם"];
								_appVue.featureSelected.address = obj["ישוב"];
								_appVue.featureSelected.rashut = obj["רשות מקומית"];
								_appVue.featureSelected.link =
									obj["למידע על פליטות מזהמים בארובות"];
							});
							//govmap.filterLayers(params);
							govmap.zoomToXY({
								x: item.x,
								y: item.y,
								level: 10,
								marker: false,
							});
						} else {
							this.featureSelected = item;
							govmap.zoomToXY({
								x: item.x,
								y: item.y,
								level: 10,
								marker: false,
							});
						}

						setTimeout(() => {
							_appVue.zoomingTo = false;
						}, 1000);
					}, 500);

					}
					
				}
			},
			toggleCollapse(index, parent_id) {
				this.selectedInfo = this.selectedInfo === index ? null : index;
				// get parent element
				if (!this.isMobile) {
					var parent = document.getElementById(parent_id);
					// scroll smoothly to parent element
					// if (parent) {
					// 	parent.scrollIntoView({ behavior: "smooth" });
					// }
				}
			},
			toggleCollapseRow(index) {
				this.selectedRow = this.selectedRow === index ? null : index;
			},
			calculateAverage(scores) {
				// Extract the values, excluding `meitzavNational`
				const values = Object.keys(scores)
					.filter((key) => key !== "meitzavNational")
					.map((key) => scores[key])
					.filter((value) => value !== null && value !== undefined); // Filter out null or undefined values

				// Check if there are no valid scores
				if (values.length === 0) {
					return null;
				}

				// Calculate the average
				const sum = values.reduce((acc, val) => acc + val, 0);
				const average = sum / values.length;

				return average;
			},
			tuggleShare() {
				this.showShare = !this.showShare;
			},
			isBtnDissabled() {
				setTimeout(() => {
					if (this.neigToAdd == null) {
						return true;
					}
					return false;
				}, 1000);
			},
			navigateTo(neigh_id) {
				var appVue = this;
				this.$router.push({
					name: "ma_basviva_neighborhood",
					params: { neighborhoodId: neigh_id },
				});
				//close modal
				this.openCompareModal = false;
				// refresh
				this.$store.state.neighborhoodId = neigh_id;
				this.$store.state.neigh_comp_search = "";
				// clear neigCompares
				this.neigCompares = [
					{
						name: "הוסף שכונה להשוואה",
						id: null,
						obj: null,
					},
					{
						name: "הוסף שכונה להשוואה",
						id: null,
						obj: null,
					},
					{
						name: "הוסף שכונה להשוואה",
						id: null,
						obj: null,
					},
				];
				appVue.$store.state.neig_searchError = false;
				//go to top
				window.scrollTo(0, 0);
				setTimeout(() => {
					window.location.reload();
				}, 10);
			},
			showCompare() {
				var appVue = this;
				this.showErrNeighMessage = false;
				this.$store.state.neig_searchError = false;
				if (this.neigCompares.filter((x) => x.obj != null).length > 1) {
					this.openModal = false;
					this.openCompareModal = true;
					// add click event -> close modal if outside
					setTimeout(() => {
						$("body").click(function (event) {
							if (
								!$(event.target).closest("#compareModal").length &&
								!$(event.target).is("#compareModal")
							) {
								appVue.openCompareModal = false;
								// remove event
								$("body").off("click");
							}
						});
					}, 500);
				} else {
					this.showErrNeighMessage = true;
				}
			},
			addNeigSearch() {
				if (
					this.$store.state.neigh_comp_search == "" ||
					this.$store.state.neigh_comp_search == null
				) {
					return;
				}
				var appVue = this;
				appVue.$store.state.neig_searchError = false;
				var url =
					this.$store.state.config.search_baseUrl +
					"/api/DetailsByQuery?query=" +
					this.$store.state.neigh_comp_search +
					"&lyrs=4&gid=nadlan";
				fetch(url)
					.then((response) => response.json())
					.then((data) => {
						if (data.length == 0) {
							appVue.$store.state.neig_searchError = true;

							return;
						}
						// convert to old id
						if (data.data["NEIGHBORHOOD"].length == 0) {
							appVue.$store.state.neig_searchError = true;

							return;
						}
						var neigh_id = (neigh_id = data.data["NEIGHBORHOOD"][0].ObjectID);
						if (
							appVue.$store.state.config.search_baseUrl ==
							"https://es.govmap.gov.il/TldSearch"
						) {
							neigh_id =
								appVue.$store.state.neigh[data.data["NEIGHBORHOOD"][0].ObjectID]
									.UNIQ_ID_OLD;
						}
						appVue.neigToAdd = {
							id: neigh_id,
							name: data.data["NEIGHBORHOOD"][0].ResultLable,
						};
						// addNeigCompare(neigh);
						this.addNeigCompare(appVue.neigToAdd);
					});
			},
			removeNeig(index) {
				this.neigCompares[index] = {
					name: "הוסף שכונה להשוואה",
					id: null,
					obj: null,
				};
				// render div again
				this.neigCompares = [...this.neigCompares];
			},
			setModal(index) {
				var appVue = this;
				$("body").off("click");
				this.showErrNeighMessage = false;
				this.getNeigborhoods();
				this.$store.state.neigh_comp_search = "";
				this.openModal = true;
				this.neigToAddIndex = index;
				this.neigToAdd = null;
				// add click event -> close modal if outside
				setTimeout(() => {
					$("body").click(function (event) {
						if (
							!$(event.target).closest("#modal_content1").length &&
							!$(event.target).is("#modal_content1")
						) {
							// if click is not on 'myInput_neighautocomplete-list'
							if (
								!$(event.target).closest("#myInput_neighautocomplete-list")
									.length &&
								!$(event.target).is("#myInput_neighautocomplete-list")
							) {
								appVue.openModal = false;
								// remove event
								$("body").off("click");
							}
						}
					});
				}, 10);

				setTimeout(() => {
					var b = document.getElementById("addNeighButton");
					b.disabled = true;
				}, 30);
			},
			getNeigborhoods() {
				// if $store.state.info hasOwnProperty otherNeighborhoodsInArea
				if (this.$store.state.info == null) {
					return;
				}
				if (
					this.$store.state.info.hasOwnProperty("otherNeighborhoodsInArea") ==
					false
				) {
					return;
				}
				this.all = [
					...new Map(
						this.$store.state.info.otherNeighborhoodsInArea.map((item) => [
							item["name"],
							item,
						]),
					).values(),
				];
				//remove from 'all' if neigCompares objects id includes all objects id
				this.neigCompares.forEach((neig) => {
					if (neig.id != null) {
						this.all.forEach((item, index) => {
							if (item.id == neig.id) {
								this.all.splice(index, 1);
							}
						});
					}
				});
				// remove current neig from all
				this.all = this.all.filter(
					(item) =>
						parseInt(item.id) !== parseInt(this.$store.state.neighborhoodId),
				);
			},
			addNeighCompare2(neigh) {
				// remove event
				$("body").off("click");

				var appVue = this;
				if (neigh == null) {
					appVue.$store.state.neig_searchError = true;
					return;
				}
				//check if neigCompares objects id includes neigh.id
				if (this.neigCompares.some((neig) => neig.id === neigh.id)) {
					return;
				}
				this.neigCompares[this.neigToAddIndex] = neigh;

				this.neigCompares.forEach((neig, index) => {
					// get info for each neigCompares object
					if (neig.id == null) {
						return;
					}
					const url =
						appVue.$store.state.config.s3_url_base +
						"/compare/neighborhood/" +
						neig.id +
						".json";
					fetch(url)
						.then((response) => response.json())
						.then((data) => {});
				});
			},
			addNeigCompare(neigh) {
				// remove event
				$("body").off("click");

				var appVue = this;
				if (neigh == null) {
					appVue.$store.state.neig_searchError = true;
					return;
				}
				//check if neigCompares objects id includes neigh.id
				if (this.neigCompares.some((neig) => neig.id === neigh.id)) {
					return;
				}
				if (neigh.id == null) {
					return;
				}
				const url =
					appVue.$store.state.config.s3_url_base +
					"/compare/neighborhood/" +
					neigh.id +
					".json";
				fetch(url)
					.then((response) => {
						if (response.status == 403) {
							appVue.$store.state.neig_searchError = true;
							return;
						}
						return response.json();
					})
					.then((data) => {
						if (data == null) {
							return;
						}

						appVue.neigCompares[appVue.neigToAddIndex] = neigh;
						appVue.neigCompares[appVue.neigToAddIndex].obj = data;
						appVue.neigCompares[appVue.neigToAddIndex].obj.trends = data.trend;
						appVue.neigToAdd = null;
						appVue.openModal = false;
					});
			},
			async waitMapLoaded() {
				if (this.mapSet == true) {
					return;
				}
				
				// this.$store.state.showMap = true;
				if (this.scriptLoaded == false) {
					await this.mixin_wait_scriptLoadedIsTrue();
				}
				if (this.$store.state.setlCode == null) {
					await this.mixin_waitForSetlUpdate(this);
				}

				setTimeout(() => {
					if (document.getElementById("map") == null) {
						this.$store.state.mapStatus = 1;
					}
					this.mixin_createMap(this);
					this.mixin_setMap(this);
	
					//add layers..
					this.mixin_displayGraphicLayer(
						this,
						"kidsGardensAndSchools",
						null,
						true,
					);
					this.mapSet = true;
				}, 100);
			},
			goToMap(layers) {
				//const el = document.getElementById("nearbyMap");
				//el.scrollIntoView({ behavior: "smooth", block: "start" });
				this.clearExisting = false;
				//delete all layers
				this.mixin_clearAllGraphicsLayers(this);

				//get ref of nearByScroller
				var obj = null;
				var educationLayers = [
					"municipalGardens",
					"privateGardens",
					"elementarySchools",
					"juniorHigh",
					"highSchools",
				];
				if (layers.every((val) => educationLayers.includes(val)) == true) {
					obj = this.$store.state.nearByMenu[0];
				}
				var greenAreaLayers = ["gardensAndParks"];
				if (layers.every((val) => greenAreaLayers.includes(val)) == true) {
					obj = this.$store.state.nearByMenu[2];
				}
				if (obj == null) {
					return;
				}
				if (this.$refs.near_by_scroller != null) {
					this.$refs.near_by_scroller.filterObj(obj);
				}

				layers.forEach((layer) => {
					setTimeout(() => {
						if (
							Object.prototype.hasOwnProperty.call(
								this.selectedNearByObject,
								"children",
							)
						) {
							this.subLayerSelected = layer;
						} else {
							this.mixin_displayGraphicLayer(
								this,
								this.selectedNearByObject.mapLayerName,
								layer,
								this.clearExisting,
							);
						}
					}, 500);
				});
				setTimeout(() => {
					this.clearExisting = true;
				}, 1000);
			},
			toggleFilterBox() {
				this.showFilterBox = !this.showFilterBox;
			},
			selectFilter(e) {
				this.selectedSubLayer = e.title;
				this.mixin_setVisibleLayers([], ["CELL_ACTIVE", "SVIVA_NITUR_MIFAL"]);
				if (
					this.$store.state.selectedNearByObject.mapLayerName == "environment"
				) {
					if (e.mapLayerName == "antennas") {
						this.mixin_setVisibleLayers(["CELL_ACTIVE"], []);
					}
					if (e.mapLayerName == "pollution") {
						this.mixin_setVisibleLayers(["SVIVA_NITUR_MIFAL"], []);
					}
					if (e.mapLayerName == "all") {
						this.mixin_setVisibleLayers(
							["CELL_ACTIVE", "SVIVA_NITUR_MIFAL"],
							[],
						);
					}
					return;
				}
				this.subLayerSelected = e.mapLayerName;
				this.layerIcon = e.layerIcon;
			},
		},

		computed: {
			mapStatus(){
				return this.$store.state.mapStatus;
			},
			placeName() {
				//if neighborhood in url ?view...
				if (this.$route.query.view == "neighborhood_info") {

					if (this.$store.state.neighborhoodName != null && this.$store.state.settlementName != null) {
						return this.$store.state.neighborhoodName + " " + this.$store.state.settlementName
					}
					else {
						return null
					}
				}
				if (this.$route.query.view == "settlement_info") {
					return this.$store.state.settlementName
				}
				return null;
			},
			// extendMap(){
			// 	return this.$store.state.extendMap;
			// },
			// footerMap(){
			// 	if (this.mapStatus > 0) {
			// 		console.log('this.mapStatus', this.mapStatus);
			// 		// return 'margin: -20px';
			// 	}
			// 	else {
			// 		// return 'margin: 0px';
			// 	}
			// },
			color() {
				const colors = {
					0: "#e0e0e0", 1: "#ff0000", 2: "#ff4500", 3: "#ff8c00", 4: "#ffa500",
					5: "#ffd700", 6: "#ffd700", 7: "#9acd32", 8: "#9acd32", 9: "#32cd32", 10: "#32cd32"
				};
				return colors[this.gaugeValue];
			},
			dashoffset() {
				if (this.gaugeValue=== 0) return 282.74;
				if (this.gaugeValue === 10) return 0;
				return 282.74 - (this.gaugeValue * 28.274);
			},
			// showMap() {
			// 	return this.$store.state.showMap;
			// },

			showMainTabs() {
				// get page from url query params...
				const urlParams = new URLSearchParams(window.location.search);
				const page = urlParams.get("page");

				var bool = true;
				// mapStatus == 2
				if ( this.mapStatus == 2) {
					bool = true;
					return bool;
				}
				// if (window.innerWidth < 1000  && this.mapStatus == 1) {
				// 	bool = false;
				// 	return bool;
				// }
				if (page == "info" && !this.isMobile) {
					if (this.scrollY >= 80) {
						bool = false;
					}
				}

				return bool;
			},

			groupedRoutes() {
				return this.route_list.reduce((acc, route) => {
					if (!acc[route.agency_name]) {
						acc[route.agency_name] = [];
					}
					acc[route.agency_name].push(route);
					return acc;
				}, {});
			},

			parksItemsAll() {
				return this.nearByObjects.gardensAndParks;
			},
			schoolsItemsAll() {
				// if (!Object.prototype.hasOwnProperty.call(this.nearByObjects, 'kidsGardensAndSchools')) return [];
				// if (this.nearByObjects.kidsGardensAndSchools == null) return [];
				const elementry =
					this.nearByObjects.kidsGardensAndSchools.elementarySchools;
				const junior = this.nearByObjects.kidsGardensAndSchools.juniorHigh;
				const high = this.nearByObjects.kidsGardensAndSchools.highSchools;
				return elementry.concat(junior, high);
			},
			kidsGardensAll() {
				const municipalGardens =
					this.nearByObjects.kidsGardensAndSchools.municipalGardens;
				const privateGardens =
					this.nearByObjects.kidsGardensAndSchools.privateGardens;
				return municipalGardens.concat(privateGardens);
			},
			gaugeValue(){
				if (this.$store.state.hasOwnProperty('luxury') && this.$store.state.luxury > 0) {
					return this.$store.state.luxury;
				}
				else if (this.additional.RealEstateIndices.hasOwnProperty('LuxuryScore') && this.additional.RealEstateIndices.LuxuryScore > 0) {
						return this.additional.RealEstateIndices.LuxuryScore;
				}
				else {
					return 0;
				}

			},
			getGaugeImage() {
				if (this.info.indexes.hasOwnProperty('luxury') && this.info.indexes.luxury.grade > 0) {
					return (
						"/images/gauge/number_" +
						this.info.indexes.luxury.grade +
						".svg"
					);
				}
				else if (this.additional.RealEstateIndices.hasOwnProperty(
					'LuxuryScore') && this.additional.RealEstateIndices.LuxuryScore > 0) {
					return (
						"/images/gauge/number_" +
						this.additional.RealEstateIndices.LuxuryScore +
						".svg"
					);
				}
				else {
					return "/images/gauge/number_0.svg";
				}
			},
			isMobile() {
				return window.innerWidth < 768;
			},
			determineClass() {
				return this.isMobile
					? "mwa-indexes__prices-list indexBox"
					: "mwa-indexes__prices-list";
			},
			getCurrentNeig() {
				return {
					name:
						this.$store.state.neighborhoodName +
						", " +
						this.$store.state.settlementName,
					id: parseInt(this.$store.state.neighborhoodId),
				};
			},
			selectedNearByObject() {
				return this.$store.state.selectedNearByObject;
			},
			infoTypeText() {
				if (this.$route.query.view == "settlement_info") {
					return "ישוב";
				}
				if (this.$route.query.view == "neighborhood_info") {
					return "שכונה";
				}
			},
			checkRouteType() {
				//var st = this.$route.name;
				var st = this.$route.query.view;
				return st;
			},
			buy_path() {
				if (typeof this.mixin_computeTargetPath().buy == "undefined") {
					return "/";
				}
				return this.mixin_computeTargetPath().buy;
			},
			rent_path() {
				if (typeof this.mixin_computeTargetPath().rent == "undefined") {
					return "/";
				}
				return this.mixin_computeTargetPath().rent;
			},
			info_path() {
				if (typeof this.mixin_computeTargetPath().info == "undefined") {
					return "/";
				}
				return this.mixin_computeTargetPath().info;
			},
		},

		watch: {
			placeName(a, b) {
				if (a == null) {
					return;
				}
				this.addMetaTag(a);
			},
			showMainTabs(before, after) {
					// if showMainTabs = true, change color ref "near_by_toolbar" background to white
					if (after == true) {
						document.getElementById("near_by_toolbar").style.backgroundColor =
							"white";
					} else {
						document.getElementById("near_by_toolbar").style.backgroundColor =
							"transparent";
					}
			},
			mapStatus(before, after) {
				var appVue = this;
				if (appVue.zoomingTo == true) {
					return;
				}
				if (appVue.mapStatus > 0) {
					appVue.zoomingTo = true;
					setTimeout(() => {
						var view = appVue.$route.query.view;
						if (view == "neighborhood_info") {
							//filter and zoom
							var params = {
								layerName: "KSHTANN_NEIGHBORHOODS",
								whereClause: "UNIQ_ID = " + appVue.$store.state.neighborhoodId,
								zoomToExtent: true,
							};
							govmap.filterLayers(params);
						} else if (view == "settlement_info") {
							// filter and zoom
							var params = {
								layerName: "KSHTANN_SETL_AREA",
								whereClause: "SETL_CODE = " + appVue.$store.state.setlCode,
								zoomToExtent: true,
							};
							govmap.filterLayers(params);
						} else {
							//zoom to settlement or neighborhood
							appVue.zoomingTo = false;
							return;
						}
						appVue.zoomingTo = false;
					}, 1000);
				}
			},
			openCompareModal() {
				//bring modal class on top of page
				if (this.openCompareModal == true) {
					document.getElementById("sticky-div").style.zIndex = 1;
				} else {
					document.getElementById("compareModal").classList.remove("active");
					// id="sticky-div" z-index = 1
					document.getElementById("sticky-div").style.zIndex = 10;
				}
			},
			neigToAddIndex() {
				if (this.neigToAddIndex != null) {
					document.getElementById("addNeighButton").disabled = false;
				}
			},
			async selectedNearByObject(obj) {
				this.featureSelected = null;
				// check if govmap loaded
				if (this.scriptLoaded == false) {
					await this.mixin_wait_scriptLoadedIsTrue();
				}
				this.mixin_setVisibleLayers([], ["CELL_ACTIVE", "SVIVA_NITUR_MIFAL"]);

				if (
					this.$store.state.selectedNearByObject.mapLayerName == "environment"
				) {
					// turn on SVIVA...
					this.mixin_setVisibleLayers(["CELL_ACTIVE", "SVIVA_NITUR_MIFAL"], []);
					// turn off all graphicLayers...
					this.mixin_clearAllGraphicsLayers(this);

					//set map click event
					await this.mixin_setMap(this);

					return;
				}

				if (!Object.prototype.hasOwnProperty.call(obj, "children")) {
					// add To Map...
					this.layerIcon = obj.layerIcon;
					this.mixin_displayGraphicLayer(
						this,
						this.$store.state.selectedNearByObject.mapLayerName,
						null,
						this.clearExisting,
					);
				} else {
					if (this.subLayerSelected != null) {
						this.mixin_displayGraphicLayer(
							this,
							this.$store.state.selectedNearByObject.mapLayerName,
							this.subLayerSelected,
							this.clearExisting,
						);
					} else {
						this.mixin_displayGraphicLayer(
							this,
							this.$store.state.selectedNearByObject.mapLayerName,
							null,
							this.clearExisting,
						);
					}
				}
			},

			subLayerSelected(e) {
				// clear all layers
				this.mixin_clearAllGraphicsLayers(this);
				if (this.subLayerSelected != null){
					// count features in subLayerSelected
					var subTypes = this.nearByObjects;
					var baseLayerName = this.$store.state.selectedNearByObject.mapLayerName;
					if (this.subLayerSelected != "all") {
						var features = subTypes[baseLayerName][this.subLayerSelected];
						if (features.length > 0) {
							this.mixin_displayGraphicLayer(
								this,
								this.$store.state.selectedNearByObject.mapLayerName,
								this.subLayerSelected,
								true,
							);
						} else {
							this.featureSelected = null;
						}
					} else {
						this.mixin_displayGraphicLayer(
							this,
							this.$store.state.selectedNearByObject.mapLayerName,
							null,
							this.clearExisting,
						);
					}
					this.adjustHeight();
				}
			
			},
		},

		mounted() {
			if (this.placeName != null) {
				this.addMetaTag(this.placeName);
			}
			this.$store.state.mapSelectionAllowed = true
			if (!this.mixin_scriptLoaded) {
				this.mixin_loadScript();
			}
			this.layerGroups = this.$store.state.nearByMenu;

			// createMap
			this.waitMapLoaded();

			//const stickyDiv = document.getElementsByClassName('sticky-div')[0];
			const stickyDiv = document.getElementById("sticky-div");
			
			// const stickyTop = 80;

			//send scroll page to top:
			window.scrollTo(0, 0);
			var appVue = this;
			window.addEventListener('scroll', () => {
				appVue.scrollY = window.scrollY;
			});
			
			appVue.$store.state.neig_searchError = false;

			appVue.$store.state.isMain = false;
			//var inputElement = document.getElementById("myInput_neigh");
			//this.mixin_setSearchBox(appVue, inputElement);
			if (appVue.$store.state.neigh == null) {
				appVue.$store.dispatch("loadNeigh");
			}
			// check if is settlement or neighborhood
			if (this.$route.query.view == "settlement_info") {
				appVue.$store.state.searchType = "SETTLEMENT";
				// get router param
				//appVue.setlCode = this.$route.params.setlCode;
				appVue.setlCode = this.$route.query.id;
				//appVue.$store.state.setlCode = this.$route.params.setlCode;
				appVue.$store.state.setlCode = this.$route.query.id;
			}
			//if (this.$route.name == "ma_basviva_neighborhood") {
			if (this.$route.query.view == "neighborhood_info") {
				appVue.$store.state.searchType = "NEIGHBORHOOD";
				// get router param
				//appVue.neighborhoodId = this.$route.params.neighborhoodId;
				appVue.neighborhoodId = this.$route.query.id;
				//appVue.$store.state.neighborhoodId = this.$route.params.neighborhoodId;
				appVue.$store.state.neighborhoodId = this.$route.query.id;
			}

			appVue.$store.state.loading = false;

			// START: get settlement / NEIGHBORHOOD info
			var url = null;
			// if is setlment
			if (appVue.$store.state.searchType == "SETTLEMENT") {
				url =
					appVue.$store.state.config.s3_url_base +
					"/additional_info/settlements/" +
					this.setlCode +
					".json";
			}
			// if is neighborhood
			if (appVue.$store.state.searchType == "NEIGHBORHOOD") {
				url =
					appVue.$store.state.config.s3_url_base +
					"/additional_info/neighborhoods/" +
					this.neighborhoodId +
					".json";
			}

			if (url == null) {
				return;
			}
			//fetch
			fetch(url)
				.then((response) => {
					response.json().then((data) => {
						appVue.mixin_setMap(appVue);
						appVue.info = data;
						appVue.nearByObjects = data;
						// 
						this.$store.state.selectedNearByObject =
							this.$store.state.nearByMenu[0];

						appVue.$store.state.info = data;
						//appVue.$store.state.settlementName = data.settlementName;
						if (
							Object.prototype.hasOwnProperty.call(data, "neighborhoodName")
						) {
							appVue.$store.state.neighborhoodName = data.neighborhoodName;
						}
						//appVue.$store.state.neighborhoodName = data.neighborhoodName;
						appVue.$store.state.setlCode = data.settlementID;

						if (
							Object.prototype.hasOwnProperty.call(data, "otherNeighborhoods")
						) {
							if (data.otherNeighborhoods != null){
								appVue.$refs.neigh_scroller.similarNeighborhoods =
								data.otherNeighborhoods;
								appVue.$store.state.similarNeighborhoods =
								data.otherNeighborhoods;
							}
							else{
								appVue.$refs.neigh_scroller.similarNeighborhoods = [];
								appVue.$store.state.similarNeighborhoods = [];
							}

						} else {
							appVue.$refs.neigh_scroller.similarNeighborhoods = [];
							appVue.$store.state.similarNeighborhoods = [];
						}

						//if neighborhood:
						if (appVue.$store.state.searchType == "NEIGHBORHOOD") {
							//get addiitional data
							const additional_info_url =
								appVue.$store.state.config.s3_url_base +
								"/additional_info/neighborhoods/" +
								appVue.$store.state.neighborhoodId +
								".json";
							fetch(additional_info_url)
								.then((response) => {
									response.json().then((data) => {
										appVue.additional = data;
										// set new bus stations
										//appVue.additional.Transportation

										// const bus_url = appVue.$store.state.config.s3_url_base + '/additional_info/bus/neighborhood/' + appVue.$store.state.neighborhoodId + '.json';
										// // fetch
										// fetch(bus_url)
										// .then((response) => response.text())
										// .then((text) => {
										// 	// Replace NaN with null in the raw text
										// 	const validJsonText = text.replace(/NaN/g, 'null');
										// 	// Parse the valid JSON text
										// 	const data = JSON.parse(validJsonText);

										// 		appVue.nearByObjects.busStations = data.BusStationsList;
										// 		appVue.additional.TransportationGlobal = appVue.additional.Transportation
										// 		appVue.additional.Transportation = data;

										// 		//
										// 		for (var i = 0; i < appVue.nearByObjects.busStations.length; i++) {
										// 			var route_list = appVue.nearByObjects.busStations[i].route_list;
										// 			appVue.nearByObjects.busStations[i].groupedRoutes = route_list.reduce((acc, route) => {
										// 				if (!acc[route.agency_name]) {
										// 					acc[route.agency_name] = [];
										// 				}
										// 				acc[route.agency_name].push(route);
										// 				return acc;
										// 			}, {});
										// 		}
										var type = "neighborhood";
										var id = appVue.$store.state.neighborhoodId;
										this.fetchBusData().then(() => {
											// if Environment in additional add to appVue.nearByObjects
											if (
												Object.prototype.hasOwnProperty.call(
													appVue.additional,
													"Environment",
												)
											) {
												appVue.nearByObjects.cell =
													appVue.additional.Environment;
											}
											appVue.svivaNiturAir();

											/// SET NICE TO MEET
											appVue.mixin_setNiceToMeets(appVue, 'neighborhood');

											if (appVue.$refs.near_by_toolbar != null) {
												appVue.$refs.near_by_toolbar.niceToMeets =
													appVue.niceToMeets;
												appVue.$refs.near_by_toolbar.setActive(0);
											}
										});
									});
								})
								.catch((error) => {});
						}
						// if is settlement
						if (appVue.$store.state.searchType == "SETTLEMENT") {
							if (appVue.$store.state.setlCode == null) {
								appVue.$store.state.setlCode = appVue.$route.query.id;
							}
							//get addiitional data
							const additional_info_url =
								appVue.$store.state.config.s3_url_base +
								"/additional_info/settlements/" +
								appVue.$store.state.setlCode +
								".json";
							fetch(additional_info_url)
								.then((response) => {
									response.json().then((data) => {
										appVue.additional = data;

										var type = "settlement";
										var id = appVue.$store.state.setlCode;
										this.fetchBusData().then(() => {
											// if Environment in additional add to appVue.nearByObjects
											if (
												Object.prototype.hasOwnProperty.call(
													appVue.additional,
													"Environment",
												)
											) {
												appVue.nearByObjects.cell =
													appVue.additional.Environment;
											}
											appVue.svivaNiturAir();

											/// SET NICE TO MEET
											appVue.mixin_setNiceToMeets(appVue, 'settlement');
											if (appVue.$refs.near_by_toolbar != null){
												appVue.$refs.near_by_toolbar.niceToMeets =
												appVue.niceToMeets;
												appVue.$refs.near_by_toolbar.setActive(0);
											}
					
										});
									});

									//});
								})
								.catch((error) => {});
						}
					});
				})
				.catch((error) => {
					this.errored = true;
				})
				.finally(() => {
					this.loading = false;
				});

			appVue.getNeigborhoods();
			// if (this.$store.state.mapStatus==0){
			// 		this.$store.state.mapStatus=1;
			// 	}


			// appVue.$store.state.showMap = true;
		},
	};
</script>

<style scoped>

#rightFilters {
	flex: 0 0 auto; /* This will allow it to take its width */
	width: auto; /* Or set a specific width */
  }


	@media screen and (max-width: 1150px) {
		.map_side_wrapper {
			width: 100%;
		}

	}



	.gauge svg {
		width: 200px;
		height: 200px;
	}
	.gauge svg text {
		font-family: 'rubik', Arial, sans-serif;
	}
	.sticky-div {
		position: -webkit-sticky; /* For Safari */
		position: fixed;
		top: 80px; /*136px Height of the header */
		z-index: 5000;
	}

	@media screen and (min-width: 768px) {
		.sticky-div {
			height: 55px;
		}
	}

	.bus_container {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 15px;
		width: 100%;
	}

	.badge-container {
		display: flex;
		border: 1px solid #ccc;
		border-radius: 8px;
		flex-direction: row;
		align-items: center;
		padding-top: 10px;
		padding-bottom: 10px;
		margin: 3px;
	}

	.agency-header {
		display: flex;
		align-items: center;
		margin-bottom: 5px;
		margin: 10px;
		flex-direction: column;
	}

	.badge-icon {
		width: fit-content;
		height: 30px;
		margin: 6px;
	}

	.agency-name {
		font-weight: bold;
		font-size: 0.8em;
	}

	.route-list {
		display: flex;
		flex-wrap: wrap;
		list-style: none;
		padding: 0;
		margin: 0;
		gap: 5px;
	}

	.route-list li {
		background-color: #f0f0f0;
		padding: 5px 10px;
		border-radius: 12px;
		white-space: nowrap;
	}

	.elipse_btn {
		justify-content: center;
		padding: 12px 14px;
		min-width: 306px;
		border-radius: 8px;
		opacity: 0.7;
		font-weight: bold;
		font-size: 20px;
		float: right;
		position: fixed;
		top: 40px;
		z-index: 3000;
		background: #fff;
		border: 1px solid #dadce0;
		box-shadow: none;
		box-sizing: border-box;
		color: #202124;
		cursor: inherit;
		display: flex;
		align-items: center;
		left: 50%;
		transform: translateX(-50%);
	}

	.overlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(
			0,
			0,
			0,
			0.5
		); /* Semi-transparent background color */
		color: white; /* Text color */
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		font-size: 24px; /* Adjust as needed */
		padding: 20px; /* Adjust as needed */
	}

	.mwa-minimap {
		position: fixed;
		z-index: 990;
		bottom: 40px;
		left: 40px;
		-webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
		box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
		display: none;
	}

	#openBottomSheet {
		position: fixed;
		bottom: 20px;
		right: 20px;
		padding: 10px 20px;
		font-size: 16px;
	}

	.bottom-sheet {
		position: fixed;
		bottom: -100%;
		left: 50%;
		transform: translateX(-50%);
		z-index: 2000000;
		max-width: 1208px;
		width: 100%;
		background-color: white;
		box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
		transition: bottom 0.3s ease;
		border-radius: 10px 10px 0 0;
	}

	.scrollmenu-container {
		/* ... other styles ... */

		/* Add transition for smooth scroll animation */
		transition: scroll-left 0.3s ease-in-out;
	}

	.fade-enter-active {
		transition: opacity 0.5s;
	}

	.fade-enter,
	.fade-leave-active {
		opacity: 0;
	}

	.bottom-sheet-content {
		padding: 20px;
	}

	

	.bottom-sheet.active {
		bottom: 0;
	}

	#closeBottomSheet {
		background: none;
		border: none;
		font-size: 16px;
		cursor: pointer;
		float: right;
		z-index: 3000;
		flex-shrink: 0;
	}

	.title img {
		margin-left: 0.5em;
	}

	.mwa-cols__item {
		display: flex;
		text-align: center;
		flex-direction: column;
		align-items: center;
	}

	/* Styles for screens 768px and above */
	@media (min-width: 768px) {
		
		.mwa-cols__item {
			
			/*justify-content: space-evenly; */
		}
		.indexesContainer {
			display: flex;

			justify-content: space-evenly;
		}
	}

	/* Styles for screens smaller than 768px */
	@media (max-width: 768px) {
		.mwa-cols__item {
			margin: 1em;
		}
	}
	/* The Modal (background) */
	.modal {
		display: block; /* Hidden by default */
		position: fixed; /* Stay in place */
		left: 0;
		max-width: 100%; /* Full width */
		z-index: 1000;
		height: 100%; /* Full height */
		overflow: auto; /* Enable scroll if needed */
		background-color: rgb(0, 0, 0); /* Fallback color */
		background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
	}

	/* Modal Content */
	.modal-content1 {
		border-radius: 30px;
		background-color: #fefefe;
		margin: auto;
		padding: 0;
		border: 1px solid #888;
		width: 80%;
		box-shadow:
			0 4px 8px 0 rgba(0, 0, 0, 0.2),
			0 6px 20px 0 rgba(0, 0, 0, 0.19);
		-webkit-animation-name: animatetop;
		-webkit-animation-duration: 0.4s;
		animation-name: animatetop;
		animation-duration: 0.4s;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 30; /* Increased z-index */
	}
	body {
		margin: 0;
		padding: 0;
		font-family: Arial, sans-serif;
	}

	.modalBody {
		overflow-y: auto;
		max-height: 100vh; /* Full screen height */
		padding: 20px;
	}

	.compareTable {
		display: flex;
		flex-wrap: wrap;
	}

	.tableCollom {
		flex: 1;
		margin: 10px;
		border: 1px solid #ddd;
		border-radius: 5px;
		overflow: hidden;
		background-color: #fff;
	}

	.cell {
		padding: 10px;
		border-bottom: 1px solid #ddd;
		position: relative;
	}

	.cell:last-child {
		border-bottom: none;
	}

	.stickyRow {
		position: sticky;
		top: 0;
		background: #fff;
		z-index: 1;
	}

	.unitedCell {
		font-weight: bold;
		background-color: #f0f0f0;
	}

	/* Media Query for Mobile View */
	@media (max-width: 768px) {
		.compareTable {
			display: block;
		}

		.tableCollom.criteriaColumn {
			display: none; /* Hide the criteria column on mobile view */
		}

		.tableCollom {
			width: 100%;
			margin: 10px 0;
		}

		.cell {
			display: block;
			padding-left: 120px; /* Adjust padding as necessary */
		}

		.cell::before {
			content: attr(data-label);
			position: absolute;
			left: 10px;
			width: 100px;
			white-space: nowrap;
			font-weight: bold;
		}

		.mini {
			font-size: 10px;
			display: block;
		}

		@media (max-width: 768px) {
			.hidden-on-mobile {
				display: none;
			}
		}
	}


	.blueText {
		color: #007bff;
	}

	
.customDropdown {
	padding: 10px 10px 10px !important;
}

.filterWrap .filterBtn {
    padding: 0 15px;
    height: 40px !important;
    margin-top: 15px;
    box-shadow: 0px 0px 4px 0px rgb(60 64 67 / 50%);
    border-radius: 10px !important;

}

.map-action-after3 {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	width: 40px;
	height: 40px;
	background-color: #ffffff; /* You can change the background color */
	border-radius: 20%;
	box-shadow: 0px 0px 4px 0px rgb(60 64 67 / 50%);
	position: absolute;
	top :20px;
	right: 5px;
}

.iconFilter {
	width: 24px;
	height: 24px
}

</style>
